// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a8134928cd8ca0ca86bf","655":"54f822c8cccf2347cf83"}[chunkId] + ".js";
};